module.exports = __webpack_public_path__ + "static/media/ic_sp_vertical.0c1d7328.svg";